
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getPaytate, getProductsList, getWeChatPayJSAPI, ProductItem } from '@/apis/my/vipPayment';
import { UserInfo } from '@/interfaces/vuexStateInterface';
import { isWechat } from '@/utils/common';
import { Dialog, Toast } from 'vant';
import i18n from '@/lang';

function sortProductItem(a: ProductItem, b: ProductItem): -1 | 0 | 1 {
  // 按照时间 倒序排列
  if (Number(a.months) < Number(b.months)) {
    return 1;
  }
  if (Number(a.months) > Number(b.months)) {
    return -1;
  }
  return 0;
}

@Component({})
export default class VipManagement extends Vue {
  private showCoursewareScreen: boolean = false // 课件同屏已下架，前端隐藏权益说明
  public tapIndex: 1 | 2 = 1;
  public isTeacher: boolean = false;
  public productsList: Array<ProductItem> = [];
    public productItemSelected: ProductItem = {};

  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo;
  }
  public timer = 0; // 开启循环，检测支付状态
  public vipTypeMap = new Map()
    .set('1', '普通VIP')
    .set('2', '超级VIP')
    .set('3', '机构普通VIP')
    .set('4', '机构超级VIP');
  

  created() {
    this.isTeacher = this.$store.state.userInfo.usertype === '1';
    this.getList();
  }

  getList() {
    // eslint-disable-next-line @typescript-eslint/camelcase
    getProductsList({ viptype: '0', product_type: this.tapIndex }).then(res => {
      this.productsList = res;//后台已经排好了，就不要再自作主张自己排了
      // eslint-disable-next-line prefer-destructuring
      this.productItemSelected = this.productsList[0];
    });
  }

  onOpenPay() {
    if(!isWechat){
      Dialog.alert({
          title: '系统提醒',
          message: '请在微信里面进行支付！',
      }).then(() => {
      });
      return;
    }
    getWeChatPayJSAPI({
      openid: this.userInfo.openid as string || localStorage.openid,
      productid: this.productItemSelected.id as string
    }).then((result:any) => {
      // @ts-ignore
      const wxInfo = JSON.parse(result.pay);
      const onBridgeReady = () => {
        window.WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          {
            appId: wxInfo.appId, // 公众号名称，由商户传入
            timeStamp: wxInfo.timeStamp, // 时间戳，自1970年以来的秒数
            nonceStr: wxInfo.nonceStr, // 随机串
            package: wxInfo.package,
            signType: wxInfo.signType, // 微信签名方式：
            paySign: wxInfo.paySign // 微信签名
          },
          res => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              // 使用以上方式判断前端返回,微信团队郑重提示：
              // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              this.$router.back();
              this.$toast(i18n.t('Homework.支付成功'));
            }
          }
        );
      };
      if (typeof window.WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
          // @ts-ignore
        } else if (document.attachEvent) {
          // @ts-ignore
          document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
          // @ts-ignore
          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
      } else {
        onBridgeReady();
      }
    });
  }

  // 开发票
  goInvoice() {
    this.$router.push({
      path: 'myAllSetting',
      query: {
        detail: 'myTradeRecord'
      }
    });
  }
}
